import React from 'react';

export const ReputationalRiskSection = ({ t }) => {
  return (
    <section id="risk" className="section-padding section-white border-t border-gray-300 relative">
      {/* Structural element */}
      <div className="absolute left-0 top-1/2 w-24 h-px bg-gray-300 transform -translate-y-1/2" />
      
      <div className="container mx-auto px-8 max-w-7xl">
        <div className="grid md:grid-cols-12 gap-20 items-start">
          {/* Left: Context */}
          <div className="md:col-span-5">
            <div className="border-l-2 border-gray-900 pl-6 mb-8">
              <p className="text-xs text-gray-600 uppercase tracking-[0.3em] font-medium">{t.risk.label}</p>
            </div>
            <h2 className="text-6xl md:text-7xl font-normal text-gray-900 mb-12 leading-[0.95] tracking-tighter" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              {t.risk.title1}<br />{t.risk.title2}<br />{t.risk.title3}
            </h2>
            <p className="text-lg text-gray-600 font-light leading-relaxed">
              {t.risk.description}
            </p>
          </div>

          {/* Right: Scenarios */}
          <div className="md:col-span-7">
            <div className="space-y-6">
              <p className="text-xs text-gray-500 uppercase tracking-widest font-light mb-10">{t.risk.scenariosLabel}</p>
              {t.risk.scenarios.map((scenario, index) => (
                <div 
                  key={index}
                  className="border-l-2 border-gray-300 hover:border-gray-900 pl-8 py-4 transition-colors relative"
                >
                  <div className="absolute left-0 top-0 w-px h-full bg-gray-200" style={{ left: '-2px' }} />
                  <span className="text-gray-800 font-light text-base leading-relaxed block">
                    {scenario}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
